import { ElementRef, Injectable, QueryList } from '@angular/core';
import { IGroupData } from '../../models/list-models';
import { map, isEqual } from 'lodash';

export interface IDisplayedHeader {
  key: string;
  human: string;
  total?: number;
  tooltip?: string;
  cellTooltip?: string;
}

@Injectable()
export class HeaderService {
  static checkHeaderShadow(scrollTop: number): boolean {
    return scrollTop === 0 ? false : true;
  }

  static checkHeaderPos(elRefs: QueryList<ElementRef>, listStickyHeader: ElementRef): number {
    const listStickyHeaderRect: DOMRect = listStickyHeader.nativeElement.getBoundingClientRect();
    const listStickyHeaderBottom: number = listStickyHeaderRect.y + listStickyHeaderRect.height;
    const list: Array<ElementRef> = elRefs.toArray();
    let headerPosition: number = 0;
    let i: number;
    for (i = list.length - 1; i > -1; i--) {
      const listHead = list[i].nativeElement.querySelector('listhead');
      if (listHead) {
        const cell = listHead.querySelector('cell');
        const cellRect = cell.getBoundingClientRect();
        const cellYPlusHalfHeight = cellRect.y + cellRect.height / 2;
        if (cellYPlusHalfHeight && cellYPlusHalfHeight < listStickyHeaderBottom) {
          headerPosition = i;
          break;
        }
      }
    }
    return headerPosition;
  }

  static getNewDisplayedHeaders(
    displayedHeaders: IDisplayedHeader[],
    headerInfo: { human: string; total: number; tooltip: string },
  ): IDisplayedHeader[] {
    let newDisplayedHeaders = Array.from(displayedHeaders);
    newDisplayedHeaders[0].human = headerInfo.human;
    newDisplayedHeaders[0].tooltip = headerInfo.tooltip;
    newDisplayedHeaders[0].total = headerInfo.total;
    return newDisplayedHeaders;
  }

  static getDisplayedHeaders(
    columns: Array<{ graphQlKey: string; columnName: string }>,
    groupData: IGroupData,
  ): IDisplayedHeader[] {
    const displayedHeaders = columns.map((col: any, indx: number) => {
      let displayedHeader: IDisplayedHeader;
      displayedHeader =
        indx === 0
          ? {
              key: col.graphQlKey,
              human: groupData.human,
              tooltip: groupData.tooltip,
              total: groupData.rowData.length,
            }
          : {
              key: col.graphQlKey,
              // update backend config to align field names
              human: col.columnName || col.label,
            };
      if (col.headerTooltip) displayedHeader.tooltip = col.headerTooltip;
      if (col.cellTooltip) displayedHeader.cellTooltip = col.cellTooltip;
      return displayedHeader;
    });
    return displayedHeaders;
  }

  static getHeaderOverflow(className: string): boolean {
    const element = document.getElementsByClassName(className)[0] as HTMLElement;
    return element.scrollWidth > element.clientWidth;
  }

  static haveHeadersChanged(oldHeaders: IDisplayedHeader[], newHeaders: IDisplayedHeader[]): boolean {
    const newHeaderKeys = map(oldHeaders, header => header.key);
    const oldHeaderKeys = map(newHeaders, header => header.key);
    return !isEqual(newHeaderKeys, oldHeaderKeys);
  }
}
